/** Build-time configuration. Every value comes from a `VITE_*` environment variable. */
const env = import.meta.env;

const mapsKey: string = (env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) ?? '';
const mapsMapId: string = (env.VITE_GOOGLE_MAPS_MAP_ID as string | undefined) || 'DEMO_MAP_ID';

const apiBase: string = (env.VITE_API_BASE_URL as string | undefined) ?? '';

export const config = {
  /** Base URL with a single trailing slash, e.g. `https://host/dev/`. */
  apiBaseUrl: apiBase === '' ? '' : apiBase.endsWith('/') ? apiBase : `${apiBase}/`,
  firebase: {
    apiKey: (env.VITE_FIREBASE_API_KEY as string | undefined) ?? '',
    authDomain: (env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined) ?? '',
    projectId: (env.VITE_FIREBASE_PROJECT_ID as string | undefined) ?? 'ethrhunt-dev',
    appId: (env.VITE_FIREBASE_APP_ID as string | undefined) ?? '',
  },
  /** The map key is public by design: it is restricted by referrer in Google Cloud, not hidden. */
  googleMaps: { apiKey: mapsKey, mapId: mapsMapId },
};

/** Resolve an API path (`api/v1/admin/scans`) against the base URL. */
export function apiUrl(path: string): string {
  return `${config.apiBaseUrl}${path.startsWith('/') ? path.slice(1) : path}`;
}
